import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import RenderComponent from './RenderComponent';
import { schema } from './validationSchema';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const ViewForm = ({
  changeRequest,
  hasApiStatus,
  callback,
  history,
  setPagination
}) => {
  const [validationError, setValidationError] = useState('');
  const [dateValidationError, setDateValidationError] = useState('');

  const handleOnSubmit = (fields) => {
    setDateValidationError('');
    if (fields.companyName || fields.startDate || fields.endDate) {
      if (
        fields.startDate &&
        moment(fields.endDate).diff(fields.startDate, 'days') < 0
      ) {
        setDateValidationError('Date To should not be less than Date From');
      } else {
        setValidationError('');
        const finalData = {
          companyName: fields.companyName || null,
          startDate: fields.startDate
            ? fields.startDate.replaceAll('/', '-')
            : null,
          endDate: fields.endDate ? fields.endDate.replaceAll('/', '-') : null
        };
        Object.keys(finalData).forEach(
          (key) => finalData[key] === null && delete finalData[key]
        );
        setPagination(true);
        changeRequest({ ...finalData });
      }
    } else {
      setValidationError('Please select atleast one filter');
    }
  };

  return (
    <>
      <Form
        type="server"
        direction="row"
        initialValues={{
          companyName: '',
          startDate: null,
          endDate: null
        }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={(fields) => {
          handleOnSubmit(fields);
        }}
        handleOnCancel={() => {
          setPagination(true);
          changeRequest();
          setValidationError('');
        }}
        customProps={{
          history,
          callback,
          hasApiStatus,
          validationError,
          dateValidationError,
          setDateValidationError
        }}
        validationSchema={schema}
      />
    </>
  );
};

ViewForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default ViewForm;
